import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import { LayoutDashboard, ClipboardList, Building } from "lucide-react";
import Overview from "@/pages/bank/Overview";
import LeadsPage from "@/pages/shared/LeadsPage";
import BankProfilePage from "@/pages/bank/BankProfilePage";

const NAV = [
  { to: "/bank", key: "dashboard", icon: LayoutDashboard, end: true },
  { to: "/bank/leads", key: "my_leads", icon: ClipboardList },
  { to: "/bank/profile", key: "profile", icon: Building },
];

export default function BankDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout title="BANK · NBFC" nav={NAV} testIdPrefix="bank-nav" />}>
        <Route index element={<Overview />} />
        <Route path="leads" element={<LeadsPage role="bank" />} />
        <Route path="profile" element={<BankProfilePage />} />
        <Route path="*" element={<Navigate to="/bank" replace />} />
      </Route>
    </Routes>
  );
}
